export class EventSignUpNotificationEmail {
  public constructor() {
    this.EventSignUpNotificationId = 0;
    this.UserNum = 0;
    this.FirstName = '';
    this.LastName = '';
    this.Email = '';
    this.EventId = 0;
  }
  public EventSignUpNotificationId: number;
  public UserNum: number;
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public EventId: number;
}
